<template>
<div>
  <div class="search-wrap">
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
    <el-button size="mini" @click="setAmountAll()">批量设置金额</el-button>
    <el-button size="mini" type="danger" @click="deleteMeterOrderAmounts()">批量删除</el-button>
    <el-button size="mini" @click="exportExcel()">导出</el-button>
    <el-button size="mini" @click="importExcel()">导入</el-button>
<!--    <el-button size="mini" @click="computeDosageNumber()">生成</el-button>-->
<!--    <el-button size="mini" @click="getExcel()">导出</el-button>-->
    <!--    <el-button size="mini" @click="ocr()">识别</el-button>-->
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费项目">
        <el-select size="mini" style="width: 100%" v-model="where.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准">
        <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed></el-table-column>
<!--      <el-table-column prop="id" label="id" width="80" fixed></el-table-column>-->
      <el-table-column prop="number" label="仪表编号"  width="150" align="center" fixed></el-table-column>
      <el-table-column prop="name" label="仪表名称"  width="200" align="center"></el-table-column>
      <el-table-column prop="hc_name" label="收费标准"  width="200" align="center">
        <template slot-scope="scope">
          <el-tag type="success" size="mini" v-if="scope.row.charge_id&&scope.row.is_master_charge">默认组</el-tag>
          <el-tag type="success" size="mini" v-if="scope.row.charge_id&&scope.row.is_one_charge">第一组</el-tag>
          <el-tag type="success" size="mini" v-if="scope.row.charge_id&&scope.row.is_two_charge">第二组</el-tag>
          <el-tag size="mini" v-if="scope.row.charge_id&&(!scope.row.is_master_charge&&!scope.row.is_one_charge&&!scope.row.is_two_charge)">额外费</el-tag>
          <span v-if="scope.row.charge_id">{{scope.row.hc_name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="step_type" label="计算方式"  width="120" align="center">
        <template slot-scope="scope">
          <el-select size="mini" v-if="scope.row.charge_id" v-model="scope.row.step_type" @change="setAmount(scope.row)">
            <el-option v-for="item in [{name:'关闭',val:0},{name:'上下级扣减前',val:1},{name:'上下级扣减后',val:2}]" :key="item.val" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额"  width="120" align="center">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-if="scope.row.charge_id" v-model="scope.row.amount" @change="setAmount(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注"  width="180" align="center">
        <template slot-scope="scope">
          <input class="number-input" v-if="scope.row.charge_id" v-model="scope.row.remarks" @change="setAmount(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="ancestor_name" label="房产"  width="320" align="center"></el-table-column>
      <el-table-column prop="update_time" label="操作时间"  width="200" align="center"></el-table-column>
      <el-table-column prop="user_name" label="操作人" width="150" align="center"></el-table-column>
      <el-table-column prop="user_name" label="操作" fixed="right" width="150" >
        <template slot-scope="scope">
          <el-button size="mini" @click="addMeterOrderAmount(scope.row)">新增</el-button>
          <el-button v-if="scope.row.charge_id" type="danger" size="mini" @click="deleteMeterOrderAmount(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
    <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>
  <SelectChargeValue ref="SelectChargeValueRef" />
</div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";
import SelectChargeValue from "../components/SelectChargeValue";

export default {
  name: "MeterOrderAmount",
  inject:['mainObj','componentId','setComponentId'],
  components: {SelectChargeValue},
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        chargeItem_name_id:"",
        charging_standard:"",
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      house_charge_item_list: [],
      house_charge_list: [],
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.getHouseChargeitemNameList();
    this.mainObj.project_id&&this.getHouseChargeList();
    this.pageChange(1)
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderAmount/getOrderList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    setAmount(item){
      const that = this;
      that.$confirm(`您是否确定修改【${item.name}】吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = ERP.reJson(item);
        MeterHttp.post("MeterOrderAmount/setAmount",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });

      });
    },
    setAmountAll(){
      const that = this;
      if(that.multipleSelection.length==0){
        that.$message({
          type: 'info',
          message: '请先选择要设置的仪表'
        });
        return;
      }
      //弹窗输入金额
      that.$prompt('请输入批量设置金额-[不设置未设收费标准的仪表]', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(([1-9]\d*)|0)(\.\d{1,2})?$/,
        inputErrorMessage: '请输入正确的金额'
      }).then(({ value }) => {
        let multipleSelection=that.multipleSelection.filter(ret=>ret.charge_id>0).map(ret=>{
          return{
            project_id:ret.project_id,
            meter_id:ret.meter_id,
            charge_id:ret.charge_id,
            amount:ret.amount,
          }
        });
        let data = {
          project_id:that.mainObj.project_id,
          meter_list:JSON.stringify(multipleSelection),
          name:'amount',
          value:value,
        }
        MeterHttp.post("MeterOrderAmount/setAmountAll",data,res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '设置成功!'
            });
            that.getList()
          }else {
            this.$message({
              type: 'info',
              message: res.msg||"修改异常"
            });
          }
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    exportExcel(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      where.house_name=that.mainObj.house_name;
      MeterHttp.post("MeterOrderAmount/exportExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          window.open(res.data)
        }
        that.loading = false;
      })

    },
    importExcel(){
      const that = this;
      MeterHttp.uploadFile(file=>{
        MeterHttp.post("MeterOrderAmount/importExcel",{
          project_id:that.mainObj.project_id,
          file:file,
          user_type:(that.$route.query.type||0),
        },res=>{
          if (res.code) {
            that.$message({
              type: 'success',
              message: '导入成功!'
            });
            that.getList()
          }else {
            this.$message({
             type: 'info',
            })
          }
        })
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    deleteMeterOrderAmount(item) {
      const that = this;
      that.$confirm(`您是否确定删除【${item.name}】的金额?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MeterHttp.post("MeterOrderAmount/deleteMeterOrderAmount", {
          project_id: that.mainObj.project_id,
          id: item.id
        }, res => {
          if (res.code) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            });
            that.getList()
          } else {
            this.$message({
              type: 'info',
              message: res.msg || "删除异常"
            });
          }
        });

      });
    },
    // 批量删除
    deleteMeterOrderAmounts() {
      const that = this;
      if (that.multipleSelection.length === 0) {
        that.$message({
          type: 'info', message: '请先选择要删除的仪表'
        });
        return;
      }
      that.$confirm(`您是否确定删除所选仪表的金额?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = that.multipleSelection.filter(ret => ret.charge_id > 0).map(ret => ret.id);
        MeterHttp.post("MeterOrderAmount/deleteMeterOrderAmounts", {
          project_id: that.mainObj.project_id,
          ids: ids.join(',')
        }, res => {
          if (res.code) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            });
            that.getList()
          } else {
            this.$message({
              type: 'info',
              message: res.msg || "删除异常"
            });
          }
        });
      });
    },
    addMeterOrderAmount(item){
      const that = this;
      that.$refs.SelectChargeValueRef.show({
        master_charge_id:item.master_charge_id,
        one_charge_id:item.one_charge_id,
        two_charge_id:item.two_charge_id,
      },ret=>{
        let data = {
          project_id: that.mainObj.project_id,
          meter_id: item.meter_id,
          charge_id: ret.charging_standard,
          amount: ret.value,
        }
        MeterHttp.post("MeterOrderAmount/addMeterOrderAmount", data, res => {
          if (res.code) {
            that.$message({
              type: 'success',
              message: '新增成功!'
            });
            that.getList()
          } else {
            this.$message({
              type: 'info',
              message: res.msg || "新增异常"
            });
          }
        });
      });
    },

  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.where2.charging_standard="";
        this.getHouseChargeList();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.number-input{
  background-color: #ffe5d5;
  color: black;
  width: 100%;
  &[disabled]{
    background-color: #ececec;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderAmount.vue